module.exports = __webpack_public_path__ + "img/icon-scan-failed-en.d69361e8.svg";